export default __webpack_public_path__ + "static/media/softclix_lancets@3x.04f7e1cf.png";